/** H5 资产列表筛选状态：进入详情后再返回时恢复 */

export const ASSET_LIST_RETURN_QS_KEY = 'yc_asset_list_return_qs';
export const ASSET_LIST_PRE_FILTER_QS_KEY = 'yc_asset_list_pre_filter_qs';
export const ASSET_LIST_ADV_FILTER_ACTIVE_KEY = 'yc_asset_list_adv_filter_active';

export function saveAssetListReturnQs(qs) {
  try {
    sessionStorage.setItem(ASSET_LIST_RETURN_QS_KEY, String(qs || ''));
  } catch {
    /* ignore */
  }
}

export function getAssetListReturnQs() {
  try {
    return sessionStorage.getItem(ASSET_LIST_RETURN_QS_KEY) || '';
  } catch {
    return '';
  }
}

export function assetListPathFromQs(qs) {
  const q = String(qs || '').replace(/^\?/, '');
  return q ? `/assets?${q}` : '/assets';
}

/** 开启高级查询前保存的列表状态，清空筛选时还原 */
export function savePreFilterQs(qs) {
  try {
    sessionStorage.setItem(ASSET_LIST_PRE_FILTER_QS_KEY, String(qs || ''));
  } catch {
    /* ignore */
  }
}

export function getPreFilterQs() {
  try {
    return sessionStorage.getItem(ASSET_LIST_PRE_FILTER_QS_KEY) || '';
  } catch {
    return '';
  }
}

export function setAdvancedFilterActive(active) {
  try {
    if (active) sessionStorage.setItem(ASSET_LIST_ADV_FILTER_ACTIVE_KEY, '1');
    else sessionStorage.removeItem(ASSET_LIST_ADV_FILTER_ACTIVE_KEY);
  } catch {
    /* ignore */
  }
}

export function isAdvancedFilterActive() {
  try {
    return sessionStorage.getItem(ASSET_LIST_ADV_FILTER_ACTIVE_KEY) === '1';
  } catch {
    return false;
  }
}
